<template>
  <div>
    <v-switch
      v-model="valueProxy"
      @change="openConfirmDialog = true"
      :label="label"
      :loading="loading"
      :dense="dense"
      :disabled="disabled"
      :color="color"
      inset
      hide-details
      :class="noMargin ? 'ma-0 pa-0' : ''"
    ></v-switch>
    <confirm-dialog
      :open.sync="openConfirmDialog"
      v-on:cancel="valueProxy = !valueProxy"
      v-on:confirm="sendConfirmEvent"
    >
      <template #title> Demande de confirmation </template>
      <slot name="confirm-text">
        Êtes-vous sûr.e de vouloir changer cette valeur ?
      </slot>
    </confirm-dialog>
  </div>
</template>
<script>
import { defineComponent, computed, ref } from "@vue/composition-api";
import ConfirmDialog from "./ConfirmDialog.vue";

export default defineComponent({
  components: {
    ConfirmDialog,
  },
  props: {
    value: Boolean,
    label: String,
    loading: Boolean,
    dense: Boolean,
    disabled: Boolean,
    color: {
      default: "primary",
      type: String,
    },
    noMargin: Boolean,
  },
  setup(props, { emit }) {
    /* Variables */
    const openConfirmDialog = ref(false);

    /* Computed */
    const valueProxy = computed({
      get: function () {
        return props.value;
      },
      set: function (val) {
        emit("update:value", val);
      },
    });

    /* Méthodes */
    const sendConfirmEvent = function () {
      emit("confirm");
    };

    return {
      valueProxy,
      openConfirmDialog,
      sendConfirmEvent,
    };
  },
});
</script>
